import 'edge/quoteandbind/common/app';
import 'angularRouter';

import RouteConfig from './config/RouteConfig';

import CPCoverablesService from '../cp/services/CPCoverablesService';
import CPDeleteBuildingService from '../cp/services/CPDeleteBuildingService';

export default angular.module('edge.quoteandbind.cp.app', ['edge.transaction.common.app', 'edge.quoteandbind.common.app', 'edge.policyjob.app']).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
    var states = new RouteConfig(RootStateConfig);
    for (var stateName in states) {
        if (states.hasOwnProperty(stateName)) {
            $stateProvider.state(stateName, states[stateName]);
        }
    }
}]).factory('qnb.cpCoverablesService', CPCoverablesService).factory('qnb.cpDeleteBuildingService', CPDeleteBuildingService);


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=cp!./common/js/src/edge/quoteandbind/cp/app.js
// module id = 473
// module chunks = 0